document.addEventListener('DOMContentLoaded', function() {
  var splitted_location = window.location.href.split('/#');
  if (splitted_location.length > 1) {
    var elem_id = splitted_location[splitted_location.length - 1];

    var elem = document.getElementById(elem_id);
    if (document.querySelectorAll(`#${elem_id}`).length > 1)
      elem = (getCookie('b2bEnabled') && getCookie('b2bEnabled') === 'true') ?
          document.querySelector(`.b2b-content #${elem_id}`) :
          document.querySelector(`.b2c-content #${elem_id}`);

    var object = $(elem).siblings('summary');
    if (object.length > 0) {
      object.trigger('click');
    }
  }
});